export default __webpack_public_path__ + "static/emily-64bc663d2ec63e4dcdced19df9b77fd7.jpg";